import { render, staticRenderFns } from "./W9CRCompanyData.vue?vue&type=template&id=c91d90aa&scoped=true&"
import script from "./W9CRCompanyData.vue?vue&type=script&lang=ts&"
export * from "./W9CRCompanyData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91d90aa",
  null
  
)

export default component.exports